// Wall-clock datetime helpers.
//
// The four user-entered datetime fields (SubDueDate, GCOwnerDeadline,
// InternalDeadline, DateBidSubmitted) and the date-only fields (ITBReceived,
// BidWalkDate, EstBidStart, EstStartDate, EstCompletionDate, DateAwarded) are
// stored as literal SQL values with no timezone. The server emits them as
// ISO strings with a trailing Z, which JS Date interprets as UTC — producing
// a -7h drift when rendered in local time.
//
// parseWallClock builds a naive local Date from the string parts (no zone
// math), so calling .toLocaleString / .toLocaleDateString / .toLocaleTimeString
// on the result renders the original wall-clock numbers verbatim.

export function parseWallClock(val) {
  if (!val) return null;
  const s = String(val).replace('Z', '');
  const parts = s.split('T');
  const dp = parts[0].split('-');
  const tp = (parts[1] || '00:00').split(':');
  if (dp.length !== 3) return null;
  return new Date(
    parseInt(dp[0]),
    parseInt(dp[1]) - 1,
    parseInt(dp[2]),
    parseInt(tp[0]) || 0,
    parseInt(tp[1]) || 0
  );
}
